module.exports = __webpack_public_path__ + "img/img_logo.09619fa0.png";